<template>
  <div class="page-main">
    <!-- 表格操作条 -->
    <vxe-toolbar ref="refToolbar" size="mini" export print custom :loading="loading">
      <template #tools>
        <span class="label">日期：</span>
        <e-date-picker type="daterange" :value.sync="pickerDate" @change="searchListData" />
      </template>
    </vxe-toolbar>

    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :loading="loading"
      :height="this.$util.getViewHeight() - 36 - 148"
      :data="tableDataMain"
      :columns="tableColumn"
      :mouse-config="{ selected: false }"
      :export-config="{ type: ['xlsx'], types: ['xlsx'] }"
      :edit-config="{ showIcon: false, trigger: 'click', mode: 'cell' }"
      :keyboard-config="{
        enterToTab: true,
        isArrow: true,
        isDel: false,
        isEnter: true,
        isTab: true,
        isEdit: false
      }"
    >
    <!-- slot_header -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filter-data="filterData"
          @change="headerFilterChange"
        />
      </template>

      <!-- slot_default -->
      <template #default_context="{ row }">
        <el-popover placement="top-start" trigger="hover" :title="row.remark || '操作内容'" width="400">
          <el-link slot="reference" type="primary" :underline="false">
            查看
          </el-link>
          <pre class="context-code scroll-bar">{{ formatContext(row.context) }}</pre>
        </el-popover>
      </template>
    
      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,

      headerFilterUrl: '/admin/logger/searchHeard',
      tableDataMain: [],
      tableColumn: [
        {
          field: 'id',
          width: 100,
          title: '编号',
          slots: { header: 'header_input' }
        },
        {
          field: 'created',
          width: 200,
          title: '日期'
        },
        {
          field: 'nick_name',
          width: 160,
          title: '用户名称',
          slots: { header: 'header_input' }
        },
        {
          field: 'user_name',
          width: 160,
          title: '账户',
          slots: { header: 'header_input' }
        },
        {
          field: 'ip',
          title: 'IP地址',
          slots: { header: 'header_input' }
        },
        {
          field: 'action',
          title: '访问地址',
          slots: { header: 'header_input' }
        },
        {
          field: 'context',
          title: '操作内容',
          width: 120,
          slots: {
            default: 'default_context'
          }
        }
      ],
      pageOptions: {
        ...this.$constant.page
      },
      filterData: {},
      sortData: {},
      pickerDate: [this.$util.getDate().sevenDay, this.$util.getDate().today] // 查询年限 月份
    }
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 格式化操作内容：是 JSON 则缩进展示，否则原样输出
    formatContext(context) {
      if (context === null || context === undefined || context === '') return '无'
      const text = typeof context === 'string' ? context : JSON.stringify(context)
      try {
        return JSON.stringify(JSON.parse(text), null, 2)
      } catch (e) {
        return text
      }
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/logger/getList',
        data: {
          currentPage: this.pageOptions.currentPage,
          pageSize: this.pageOptions.pageSize,
          pickerDate: this.pickerDate,
          sortData: this.sortData,
          filterData: this.filterData
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.tableDataMain = res.data.list
            this.pageOptions.pageSize = res.data.pageSize
            this.pageOptions.total = res.data.totalRow
            this.pageOptions.currentPage = res.data.pageNumber
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    }
  },
  created() {
    this.$nextTick(() => {
      this.getListData()
      this.$refs.refTable.connect(this.$refs.refToolbar) // 手动将表格和工具栏进行关联
    })
  }
}
</script>
<style lang="less" scoped>
.page-main {
}
</style>
<style lang="less">
.el-popover .context-code {
  max-height: 300px;
  margin: 0;
  padding: 8px;
  overflow-y: auto;
  font-family: Consolas, Monaco, 'Courier New', monospace;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  background: #f5f7fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
</style>
